<template>
  <v-main>
    <router-view />

    <!-- <dashboard-core-footer /> -->
  </v-main>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import auth from '@/plugins/auth.js'

  export default {
    name: 'DashboardCoreView',

    components: {
      // DashboardCoreFooter: () => import('./Footer'),
    },
    data () {
      return {
        polling: null,
      }
    },
    computed: {
      ...mapState(['auth']),
    },
    mounted () {
      if (!this.$store.state.auth.accessToken) {
        this.logout()
        return
      }
      // attivo polling sul token, ogni 8 minuti refresho il token
      this.polling = setInterval(this.refreshToken, 8 * 60 * 1000)
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      ...mapActions([
        'logout',
        'storeAuth',
      ]),
      refreshToken: function () {
        auth
          .keepToken(this.$store.state.auth.refreshToken)
          .then((response) => {
            if (response.status === 401) {
              // alert('Expired Session')
              this.$store.commit('setSnack', { message: 'Session Expired', color: '#c54747d4' })
              this.logout()
              return
            }
            return response.json()
          })
          .then((jsonData) => {
            console.log('Token Refresh', jsonData)
            if (!jsonData.accessToken) {
              this.logout()
            }
            if (jsonData !== undefined && jsonData !== null && jsonData !== '') {
              if (!jsonData.userinfo) {
                sessionStorage.setItem('logged', 'false')
                this.logout()
              }
              this.storeAuth(jsonData)
            }
          })
          .catch((error) => {
            // alert('error on refreshtoken')
            this.$store.commit('setSnack', { message: 'Refreshing Token Error', color: '#c54747d4', timeout: -1 })
            this.logout()
            console.error('ERR', error)
          })
      },
    },
  }
</script>
